import React, { Component } from 'react'
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { layoutActions } from '../../store/layoutStore';

class NavigationRow extends Component {
    render() {
        return (
            <div className='bottom-panel'>
                <div className='bottom-panel-inner'>
                    <div className='navigation-row' style={{ display:"flex", justifyContent: this.props.justify, alignItems:'center' }}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => { return { layout: state.layout } },
    dispatch => bindActionCreators(layoutActions, dispatch))(NavigationRow);

